<!-- <div class="card">
    <div class="font-semibold text-xl mb-4">Filtering</div>
    <p-table
        #dt1
        [value]="customers1"
        dataKey="id"
        [rows]="10"
        [loading]="false"
        [rowHover]="true"
        [showGridlines]="true"
        [paginator]="true"
        [globalFilterFields]="[
            'name',
            'country.name',
            'representative.name',
            'status'
        ]"
        responsiveLayout="scroll"
    >
        <ng-template #caption>
            <div class="flex justify-between items-center flex-col sm:flex-row">
                <button
                    pButton
                    label="Clear"
                    class="p-button-outlined mb-2"
                    icon="pi pi-filter-slash"
                    (click)="clear(dt1)"
                ></button>
                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input
                        pInputText
                        type="text"
                        (input)="onGlobalFilter(dt1, $event)"
                        placeholder="Search keyword"
                    />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="min-width: 12rem">
                    <div class="flex justify-between items-center">
                        Name
                        <p-columnFilter
                            type="text"
                            field="name"
                            display="menu"
                            placeholder="Search by name"
                        ></p-columnFilter>
                    </div>
                </th>
                <th style="min-width: 12rem">
                    <div class="flex justify-between items-center">
                        Country
                        <p-columnFilter
                            type="text"
                            field="country.name"
                            display="menu"
                            placeholder="Search by country"
                        ></p-columnFilter>
                    </div>
                </th>
                <th style="min-width: 14rem">
                    <div class="flex justify-between items-center">
                        Agent
                        <p-columnFilter
                            field="representative"
                            matchMode="in"
                            display="menu"
                            [showMatchModes]="false"
                            [showOperator]="false"
                            [showAddButton]="false"
                        >
                            <ng-template #header>
                                <div class="px-4 pt-4 pb-0">
                                    <span class="font-bold">Agent Picker</span>
                                </div>
                            </ng-template>
                            <ng-template
                                #filter
                                let-value
                                let-filter="filterCallback"
                            >
                                <p-multi-select
                                    [ngModel]="value"
                                    [options]="representatives"
                                    placeholder="Any"
                                    (onChange)="filter($event.value)"
                                    optionLabel="name"
                                    styleClass="w-full"
                                >
                                    <ng-template let-option #item>
                                        <div
                                            class="flex items-center gap-2 w-44"
                                        >
                                            <img
                                                [alt]="option.label"
                                                src="/demo/images/avatar/{{
                                                    option.image
                                                }}"
                                                width="32"
                                            />
                                            <span>{{ option.name }}</span>
                                        </div>
                                    </ng-template>
                                </p-multi-select>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>
                <th style="min-width: 10rem">
                    <div class="flex justify-between items-center">
                        Date
                        <p-columnFilter
                            type="date"
                            field="date"
                            display="menu"
                            placeholder="mm/dd/yyyy"
                        ></p-columnFilter>
                    </div>
                </th>
                <th style="min-width: 10rem">
                    <div class="flex justify-between items-center">
                        Balance
                        <p-columnFilter
                            type="numeric"
                            field="balance"
                            display="menu"
                            currency="USD"
                        ></p-columnFilter>
                    </div>
                </th>
                <th style="min-width: 12rem">
                    <div class="flex justify-between items-center">
                        Status
                        <p-columnFilter
                            field="status"
                            matchMode="equals"
                            display="menu"
                        >
                            <ng-template
                                #filter
                                let-value
                                let-filter="filterCallback"
                            >
                                <p-select
                                    [ngModel]="value"
                                    [options]="statuses"
                                    (onChange)="filter($event.value)"
                                    placeholder="Any"
                                    [style]="{ 'min-width': '12rem' }"
                                >
                                    <ng-template let-option #item>
                                        <span
                                            [class]="
                                                'customer-badge status-' +
                                                option.value
                                            "
                                            >{{ option.label }}</span
                                        >
                                    </ng-template>
                                </p-select>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>
                <th style="min-width: 12rem">
                    <div class="flex justify-between items-center">
                        Activity
                        <p-columnFilter
                            field="activity"
                            matchMode="between"
                            display="menu"
                            [showMatchModes]="false"
                            [showOperator]="false"
                            [showAddButton]="false"
                        >
                            <ng-template #filter let-filter="filterCallback">
                                <p-slider
                                    [ngModel]="activityValues"
                                    [range]="true"
                                    (onSlideEnd)="filter($event.values)"
                                    styleClass="m-4"
                                    [style]="{ 'min-width': '12rem' }"
                                ></p-slider>
                                <div
                                    class="flex items-center justify-between px-2"
                                >
                                    <span>{{ activityValues[0] }}</span>
                                    <span>{{ activityValues[1] }}</span>
                                </div>
                            </ng-template>
                        </p-columnFilter>
                    </div>
                </th>
                <th style="min-width: 8rem">
                    <div class="flex justify-between items-center">
                        Verified
                        <p-columnFilter
                            type="boolean"
                            field="verified"
                            display="menu"
                        ></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-customer>
            <tr>
                <td>
                    {{ customer.name }}
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <img
                            src="https://primefaces.org/cdn/primeng/images/flag/flag_placeholder.png"
                            [class]="'flag flag-' + customer.country.code"
                            width="30"
                        />
                        <span>{{ customer.country.name }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <img
                            [alt]="customer.representative.name"
                            src="/demo/images/avatar/{{
                                customer.representative.image
                            }}"
                            width="32"
                            style="vertical-align: middle"
                        />
                        <span class="image-text">{{
                            customer.representative.name
                        }}</span>
                    </div>
                </td>
                <td>
                    {{ customer.date | date: 'MM/dd/yyyy' }}
                </td>
                <td>
                    {{ customer.balance | currency: 'USD' : 'symbol' }}
                </td>
                <td>
                    <p-tag
                        [value]="customer.status.toLowerCase()"
                        [severity]="getSeverity(customer.status)"
                    />
                </td>
                <td>
                    <p-progressbar
                        [value]="customer.activity"
                        [showValue]="false"
                        [style]="{ height: '0.5rem' }"
                    />
                </td>
                <td>
                    <span class="flex justify-center items-center">
                        <i
                            class="pi"
                            [ngClass]="{
                                'text-green-500 pi-check-circle':
                                    customer.verified,
                                'text-red-500 pi-times-circle':
                                    !customer.verified
                            }"
                        ></i>
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="8">No customers found.</td>
            </tr>
        </ng-template>
        <ng-template #loadingbody>
            <tr>
                <td colspan="8">Loading customers data. Please wait.</td>
            </tr>
        </ng-template>
    </p-table>
</div> -->

<div class="table-container">
    <p-table
        #dt1
        [value]="dclCards() ?? []"
        [lazy]="true"
        dataKey="id"
        class="dcl-cards no-grid-lines"
        [rows]="10"
        [loading]="loading()"
        [totalRecords]="totalRecords"
        [rowHover]="true"
        [resizableColumns]="true"
        [reorderableColumns]="false"
        [showGridlines]="true"
        [columnResizeMode]="'fit'"
        stateStorage="local"
        stateKey="dcl-cards-table"
        [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} εώς {last} από {totalRecords}"
        [rowsPerPageOptions]="[10, 25, 50]"
        (onLazyLoad)="onLazyLoad($event)"
    >
        <ng-template #caption>
            <div class="flex items-center justify-between">
                <span class="text-xl font-bold"></span>
                <div class="flex gap-2">
                    <!-- <button
                        pButton
                        label="Νέα Εγγραφή"
                        class="p-button-outlined mb-2"
                        (click)="newDCL()"
                        raised
                    ></button> -->
                    <p-button
                        icon="pi pi-plus"
                        rounded
                        raised
                        (onClick)="newDCL()"
                    />
                    <p-button
                        icon="pi pi-refresh"
                        (onClick)="refreshTable(true)"
                        rounded
                        raised
                    />
                </div>
            </div>

            <!-- <div class="flex justify-between items-center flex-col sm:flex-row">
                <span>Εγγραφές</span>
                <button
                    pButton
                    label="Νέα Εγγραφή"
                    class="p-button-outlined mb-2"
                    icon="pi pi-filter-slash"
                    (click)="newDCL()"
                ></button>
                <button
                    pButton
                    label="Clear"
                    class="p-button-outlined mb-2"
                    icon="pi pi-filter-slash"
                    (click)="clear(dt1)"
                ></button>

                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input
                        pInputText
                        type="text"
                        (input)="dt1.filterGlobal($event.target.value ?? '', 'contains')"
                        placeholder="Search keyword"
                    />
                </p-iconfield>
            </div> -->
        </ng-template>
        <ng-template #header>
            <tr>
                <!-- <th pSortableColumn="Garage.VehicleRegistrationNumber">
                    <div class="flex justify-between items-center">
                        Ημερομηνία Εγγραφής
                        
                    </div>
                </th> -->
                <th style="text-align: center" pResizableColumn>
                    Αριθμός Κυκλοφορίας
                </th>
                <th style="text-align: center" pResizableColumn>
                    Ημερομηνία Υποβολής
                </th>
                <th style="text-align: center" pResizableColumn>
                    Αριθμός Ψηφιακού Πελατολογίου
                </th>
                <th style="text-align: center" pResizableColumn>
                    Ημερομηνία Εξόδου
                </th>
                <th style="text-align: center" pResizableColumn>
                    Παρεχόμενη Υπηρεσία
                </th>

                <th pResizableColumn>
                    <div
                        class="flexq justify-betweenq items-centerq w-full"
                        style="text-align: center"
                    >
                        Στοιχεία Παραστατικού
                        <!-- <p-columnFilter
                            type="text"
                            field="name"
                            display="menu"
                            placeholder="Search by name"
                        ></p-columnFilter>
                        <p-sortIcon field="code" /> -->
                    </div>
                </th>
                <th></th>
                <!-- <th pSortableColumn="EntryCompletion">
                    <div class="flex justify-between items-center">
                        Κατάσταση
                        <p-columnFilter
                            type="text"
                            field="name"
                            display="menu"
                            placeholder="Search by name"
                        ></p-columnFilter>
                        <p-sortIcon field="EntryCompletion" />
                    </div>
                </th> -->
            </tr>
        </ng-template>
        <ng-template #body let-dclCard let-rowIndex="rowIndex">
            @let lastInvoiceIndex = (dclCard.Invoices?.length ?? 0) - 1;
            <!-- @let creationDateTime = dclCard.CreationDateTime; -->

            <!-- @let lastInvoiceResponse =
                dclCard.Invoices?.[lastInvoiceIndex]?.Response;
            @let lastInvoice = dclCard.Invoices?.[lastInvoiceIndex];

            @let statusCode = lastInvoice?.DCLCorrelationResponse?.StatusCode; -->
            <!-- @let correlationId = invoice?.DCLCorrelationId; -->

            <tr
                (dblclick)="onRowDblClick(dclCard, rowIndex)"
                [ngClass]="
                    dclCard.CompletionDateTime != undefined
                        ? 'dcl-record-completed-successfull'
                        : ''
                "
            >
                <!-- <td>
                    {{ dclCard.UsersActions.CreatedDate | zDate: 'short' }}
                </td> -->
                <td style="text-align: center">
                    {{
                        dclCard.Garage?.VehicleRegistrationNumber
                            | zPlateFormat: dclCard.Garage?.IsForeign
                    }}
                </td>
                <td style="text-align: center">
                    <!-- Ημερομηνία Υποβολής -->

                    {{
                        dclCard.CreationDateTime
                            | zDate: dt.DATETIME_SHORT_WITH_SECONDS
                    }}
                </td>
                <td style="text-align: center">{{ dclCard.DCLNewId }}</td>
                <td style="text-align: center">
                    @if (
                        dclCard.CreationDateTime != undefined &&
                        dclCard.ProvidedServiceCategory != undefined &&
                        dclCard.CompletionDateTime == undefined
                    ) {
                        <p-button
                            label="Έξοδος Οχήματος"
                            title="Πατήστε για να εξέλθει το όχημα από την εγκατάσταση"
                            severity="warn"
                            icon="pi pi-sign-out"
                            [iconPos]="'right'"
                            (onClick)="onRowDblClick(dclCard, rowIndex)"
                        />
                    } @else {
                        {{
                            dclCard.CompletionDateTime
                                | zDate: dt.DATETIME_SHORT_WITH_SECONDS
                        }}
                    }
                </td>
                <td style="text-align: center">
                    @if (dclCard.ProvidedServiceCategory == undefined) {
                        <p-button
                            label="Προσθήκη Υπηρεσίας"
                            title="Πατήστε για να επιλέξετε το είδος της Παρεχόμενης Υπηρεσίας στην εγγραφή του Ψηφιακού Πελατολογίου"
                            severity="warn"
                            icon="pi pi-pen-to-square"
                            [iconPos]="'right'"
                            (onClick)="onRowDblClick(dclCard, rowIndex)"
                        />
                    } @else {
                        @switch (dclCard.ProvidedServiceCategory) {
                            @case (1) {
                                <span>Εργασία με χρήση ανταλλακτικών</span>
                            }
                            @case (2) {
                                <span
                                    >Εργασία με χρήση ανταλλακτικών πελάτη</span
                                >
                            }
                            @case (3) {
                                <span>Εργασία χωρίς χρήση ανταλλακτικών</span>
                            }
                            @case (4) {
                                <span>Δωρεάν υπηρεσία</span>
                            }
                            @case (5) {
                                <span>Λοιπά</span>
                            }
                            @case (6) {
                                <span>Αποζημίωση Παροχής Εγγύησης</span>
                            }
                            @case (7) {
                                <span>Υπηρεσία Βάσει Τιμοκαταλόγου</span>
                            }
                            @case (8) {
                                <span>Υπηρεσία Κατόπιν Συμφωνίας</span>
                            }
                            @case (9) {
                                <span>Ιδιόχρηση</span>
                            }
                        }
                    }
                </td>
                <td
                    style="text-align: center; align-items: center"
                    class="flex flex-row glex-wrap gap-2"
                >
                    @if (lastInvoiceIndex >= 0) {
                        @for (invoice of dclCard.Invoices; track invoice) {
                            @let invoiceMark =
                                invoice?.Response?.InvoiceMark ?? 0;
                            @let invoiceTypeCode = invoice?.TypeCode;
                            @let invoiceURI =
                                invoice?.Response?.InvoiceUrl ?? '';

                            @switch (invoiceTypeCode) {
                                @case ('11.1') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Απόδειξη Λιανικής Πώλησης (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}
                                        </a>
                                    } @else {
                                        <!-- Σε Αναμονή -->
                                        <!-- 205-08-15: Εδώ εμφανίζαμε ένα κουμπάκι για να κάνει edit το Παραστατικό. Το αφαιρούμε αυτο για απλούστερο UX -->
                                        <!-- <p-button
                                        label="Απόδειξη Λιανικής Πώλησης"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                                @case ('11.2') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Απόδειξη Παροχής Υπηρεσιών (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}</a
                                        >
                                    } @else {
                                        <!-- Σε Αναμονή -->
                                        <!-- <p-button
                                        label="Απόδειξη Παροχής Υπηρεσιών"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                                @case ('2.1') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Τιμολόγιο Παροχής Υπηρεσιών (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}</a
                                        >
                                    } @else {
                                        <!-- <p-button
                                        label="Τιμολόγιο Παροχής Υπηρεσιών"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                                @case ('1.1') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Τιμολόγιο Πώλησης (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}
                                        </a>
                                    } @else {
                                        <!-- <p-button
                                        label="Τιμολόγιο Πώλησης"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                                @case ('1.1-9.3') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Τιμολόγιο Πώλησης / Δελτίο Αποστολής (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}</a
                                        >
                                    } @else {
                                        <!-- <p-button
                                        label="Τιμολόγιο Πώλησης / Δελτίο Αποστολής"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                                @case ('9.3') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Δελτίο Αποστολής (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}</a
                                        >
                                    } @else {
                                        <!-- <p-button
                                        label="Δελτίο Αποστολής"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                                @case ('11.4') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Πιστωτικό Στοιχ. Λιανικής (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}</a
                                        >
                                    } @else {
                                        <!-- <p-button
                                        label="Πιστωτικό Στοιχ. Λιανικής"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                                @case ('5.2') {
                                    @if (invoiceMark != 0) {
                                        <a
                                            title="Πιστωτικό Τιμολόγιο (Μ.ΑΡ.Κ : {{
                                                invoice?.Response?.InvoiceMark
                                            }})"
                                            class="provider-invoice-link"
                                            href="{{ invoiceURI }}"
                                        >
                                            {{ invoice?.Series }}&nbsp;/&nbsp;{{
                                                invoice?.AA
                                            }}</a
                                        >
                                    } @else {
                                        <!-- <p-button
                                        label="Πιστωτικό Τιμολόγιο"
                                        title="Πατήστε για προβολή ή/και μεταβολή του παραστατικού"
                                        variant="text"
                                        severity="help"
                                        variant="text"
                                        (onClick)="
                                            editInvoice(
                                                dclCard,
                                                lastInvoiceIndex
                                            )
                                        "
                                    /> -->
                                    }
                                }
                            }
                        }
                    } @else {
                        <!-- <p-button
                                    icon="pi pi-plus"
                                    [rounded]="true"
                                    [text]="true"
                                    [size]="'small'"
                                    severity="danger"
                                    (onClick)="newInvoice(dclCard, '11.2')"
                                /> -->
                        <!-- dclCard.CompletionDateTime != undefined && -->
                        <!-- @if (
                            dclCard.ProvidedServiceCategory == 1 ||
                            dclCard.ProvidedServiceCategory == 2 ||
                            dclCard.ProvidedServiceCategory == 3
                        ) {
                            <p-button
                                label="Παραστατικό"
                                title="Πατήστε για να προσθέσετε ένα νέο Παραστατικό (Τιμολόγιο / Απόδειξη) στην εγγραφή του Ψηφιακού Πελατολογίου"
                                severity="success"
                                icon="pi pi-plus"
                                [iconPos]="'right'"
                                (onClick)="newInvoice(dclCard, '11.2')"
                            />
                        } -->
                    }

                    <!-- 
1 = ΑΛΠ/ΑΠΥ
    11.1 : Παραστατικά Λιανικής -> ΑΛΠ
    11.2 : Παραστατικά Λιανικής -> ΑΠΥ
    11.4 : Παραστατικά Λιανικής ->  Πιστωτικό Στοιχ. Λιανικής
2 = ΤΙΜΟΛΟΓΙΟ 
    1.1 : Τιμολόγιο Πώλησης -> Τιμολόγιο Πώλησης
    2.1 : Τιμολόγιο Παροχής Υπηρεσιών -> Τιμολόγιο Παροχής
    5.2 : Πιστωτικό Τιμολόγιο -> Πιστωτικό Τιμολόγιο / Μη Συσχετιζόμενο
3 = ΑΛΠ/ΑΠΥ-ΦΗΜ

---
    8.1 : 
 -->
                    <!-- <button
                        pButton
                        label="Νέο Παραστατικό"
                        class="p-button-outlined mb-2"
                        (click)="newInvoice(dclCard)"
                        raised
                         // {
            //     _id: '11.1',
            //     TypeCode: '11.1',
            //     Title: 'Απόδειξη Λιανικής Πώλησης'
            // } as IAADEInvoiceType,
            {
                _id: '11.2',
                TypeCode: '11.2',
                Title: 'Απόδειξη Παροχής Υπηρεσιών'
            } as IAADEInvoiceType,
            {
                _id: '2.1',
                TypeCode: '2.1',
                Title: 'Τιμολόγιο Παροχής Υπηρεσιών'
            } as IAADEInvoiceType
            // {
            //     _id: '1.1',
            //     TypeCode: '1.1',
            //     Title: 'Τιμολόγιο Πώλησης'
            // } as IAADEInvoiceType,
            // {
            //     _id: '1.1-9.3',
            //     TypeCode: '1.1-9.3',
            //     Title: 'Τιμολόγιο Πώλησης / Δελτίο Αποστολής'
            // } as IAADEInvoiceType,
            // {
            //     _id: '9.3',
            //     TypeCode: '9.3',
            //     Title: 'Δελτίο Αποστολής'
            // } as IAADEInvoiceType,
            // // --------------------- uncoment for test if needed
            // {
            //     _id: '11.4',
            //     TypeCode: '11.4',
            //     Title: 'Πιστωτικό Στοιχ. Λιανικής'
            // } as IAADEInvoiceType,
            // {
            //     _id: '5.2',
            //     TypeCode: '5.2',
            //     Title: 'Πιστωτικό Τιμολόγιο'
            // } as IAADEInvoiceType

                    ></button> -->
                    <!-- <div class="flex flex-row gap-3">
                        <div class="flex flex-col gap-3">
                            @for (
                                invoice of dclCard.Invoices;
                                track invoice;
                                let index = $index
                            ) {
                                <div
                                    class="dcl-invoice"
                                    style="cursor: pointer"
                                    (click)="editInvoice(dclCard, index)"
                                >
                                    {{ index + 1 }}: {{ invoice._id }}
                                </div>
                            }
                        </div>
                    </div> -->

                    <!-- <z-split-button
                        [items]="splitButtonItems"
                        [itemObj]="dclCard"
                        (selectedItemChange)="onSelectedItemChange($event)"
                    ></z-split-button> -->
                    <!-- <p-splitbutton
                        label="{{ selectedMenuItem.label }}"
                        title="{{ selectedMenuItem.title }}"
                        (onDropdownClick)="onDropdownClick($event, dclCard)"
                        (onClick)="
                            newInvoice(dclCard, selectedMenuItem['code'])
                        "
                        [model]="splitButtonItems"
                        severity="warn"
                    /> -->
                </td>
                <td>
                    <!-- @if (
                        creationDateTime > '2025-08-01T00:00:00.000Z' &&
                        (lastInvoiceResponse?.InvoiceMark ?? 0) != 0 &&
                        dclCard.CompletionDateTime != undefined &&
                        (dclCard.ProvidedServiceCategory == 1 ||
                            dclCard.ProvidedServiceCategory == 2 ||
                            dclCard.ProvidedServiceCategory == 3)
                    ) {
                        @if (
                            invoice?.DCLCorrelationResponse == undefined ||
                            (statusCode != undefined &&
                                statusCode?.toLocaleLowerCase() !=
                                    'Success'.toLocaleLowerCase())
                        ) {
                            <p-button
                                label="Συσχέτιση"
                                title="Το Παραστατικό δεν έχει συσχετιστεί με την εγγραφή του Ψηφιακού Πελατολογίου. Πατήστε για να ολοκληρωθεί η συσχέτιση."
                                severity="danger"
                                icon="pi pi-link"
                                [iconPos]="'right'"
                                (onClick)="correlate(dclCard, invoice)"
                            />
                        }
                    } -->
                </td>
                <!-- <td></td> -->
            </tr>
        </ng-template>
    </p-table>
</div>

<div>
    <!-- <p-toast position="bottom-right" /> -->
    <p-confirmdialog>
        <ng-template #message let-message>
            <div
                class="flex flex-col gap-4 items-center w-full border-b border-surface-200 dark:border-surface-700 p-4 text-xl"
            >
                <div class="flex flex-row flex-wrap gap-4">
                    <!-- <i
                        [ngClass]="message.icon"
                        class="text-8xl text-primary-500"
                        style="color: var(--p-button-warn-background)"
                    ></i> -->
                    <span>
                        {{ message.message }}
                    </span>
                    <!-- <span style="color: var(--p-button-info-focus-ring-color)">
                        {{ message.message }}
                    </span> -->
                </div>

                <!-- <p>
                    <span
                        class="text-base"
                        style="color: var(--p-button-danger-background)"
                        >Η ενέργεια αυτή δεν μπορεί να ακυρωθεί.</span
                    >
                </p> -->
            </div>
        </ng-template>
    </p-confirmdialog>
</div>
